import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Ventrata} from 'types'

export const useGetConfigApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(async () => {
    const {data} = await ventrata.get<Ventrata.Config>(`/ventrata/checkout/config`, {
      headers: {
        'Octo-Capabilities': 'ventrata/checkout',
      },
    })

    return data
  }, [ventrata])
}
